export default function MRangeHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#0A0A0A] via-[#0D1117] to-[#000000] pt-32">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="/images/014b41d04a33.webp"
          alt="M Series Modular Space Capsule"
          className="w-full h-full object-cover object-center opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      {/* Cyan Glow Effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-black/50 backdrop-blur-sm border border-cyan-500/30 rounded-full mb-8 shadow-[0_0_20px_rgba(0,217,255,0.2)]">
          <div className="w-8 h-8 bg-cyan-500 rounded-full flex items-center justify-center">
            <span className="text-lg font-bold text-black">M</span>
          </div>
          <span className="text-cyan-400 text-sm uppercase tracking-widest font-medium">Modular Series</span>
        </div>

        <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-thin mb-6 text-white leading-tight">
          M Series: Modular<br />
          <span className="font-light text-cyan-400">Anywhere Access</span>
        </h1>

        <p className="text-lg sm:text-xl lg:text-2xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed">
          Revolutionary modular design for locations where cranes cannot reach. 
          Piece-by-piece assembly brings luxury living to the most remote destinations.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a 
            href="#models"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('models')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="group inline-flex items-center gap-3 px-8 py-4 bg-cyan-500 text-black text-base font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.5)] whitespace-nowrap cursor-pointer"
          >
            Explore Models
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center group-hover:shadow-lg transition-all">
              <i className="ri-arrow-down-line text-cyan-400"></i>
            </div>
          </a>
          <a 
            href="#features"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="group inline-flex items-center gap-3 px-8 py-4 bg-black/50 backdrop-blur-sm text-white text-base font-medium rounded-full border border-cyan-500/30 hover:bg-cyan-500/10 hover:border-cyan-500/50 transition-all hover:shadow-[0_0_20px_rgba(0,217,255,0.3)] whitespace-nowrap cursor-pointer"
          >
            View Features
            <i className="ri-puzzle-line text-xl text-cyan-400"></i>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-cyan-500/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-cyan-500 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
